import React from "react";

export default function AppTermsOfUse() {
  return (
    <div className="app-container">
      <div className="background-pattern"></div>

      <div className="main-content">
        <div className="legal-header">
          <img
            src="/logo.png"
            alt="Auto Shiny Counter Logo"
            className="app-logo"
          />
          <h1 className="title">App Terms of Use</h1>
          <p className="legal-date">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>Auto Shiny Counter App Terms of Use</h2>
            <p>
              These Terms of Use ("Terms") govern your use of the Auto Shiny
              Counter mobile application ("the App") developed by Sebastian
              Wagner. By downloading, installing, or using the App, you
              agree to be bound by these Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>Acceptance of Terms</h2>
            <p>
              By using the App, you acknowledge that you have read, understood,
              and agree to be bound by these Terms. If you do not agree to these
              Terms, do not use the App.
            </p>
          </section>

          <section className="legal-section">
            <h2>App Description</h2>
            <p>
              Auto Shiny Counter is a utility app designed to help players track
              their shiny hunting resets. The App uses your device's camera to
              automatically count resets and provides manual counting options.
            </p>
          </section>

          <section className="legal-section">
            <h2>License and Usage</h2>
            <p>
              We grant you a limited, non-exclusive, non-transferable, revocable
              license to use the App for your personal, non-commercial use in
              accordance with these Terms.
            </p>
            <p>You agree not to:</p>
            <ul>
              <li>Use the App for any illegal or unauthorized purpose</li>
              <li>Attempt to reverse engineer, decompile, or modify the App</li>
              <li>Use the App to violate any applicable laws or regulations</li>
              <li>Interfere with or disrupt the App's functionality</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>In-App Purchases and Subscriptions</h2>
            <p>
              The App offers in-app subscription purchases that provide
              additional features and functionality. By purchasing a
              subscription, you agree to the following terms:
            </p>
            <p>
              <strong>Available Subscriptions:</strong>
            </p>
            <ul>
              <li>1 Month Subscription</li>
              <li>1 Year Subscription</li>
            </ul>
            <p>
              <strong>Subscription Terms:</strong>
            </p>
            <ul>
              <li>
                Subscriptions automatically renew at the end of each billing
                period
              </li>
              <li>
                You will be charged the subscription fee at the beginning of
                each billing period
              </li>
              <li>
                You can cancel your subscription at any time through your
                device's app store settings
              </li>
              <li>
                Cancellation will take effect at the end of the current billing
                period
              </li>
              <li>
                No refunds will be provided for partial subscription periods
              </li>
              <li>Subscription prices may change with notice</li>
            </ul>
            <p>
              <strong>Payment Processing:</strong> All payments are processed by
              the respective app stores (Apple App Store or Google Play Store)
              and are subject to their terms of service and privacy policies.
            </p>
          </section>

          <section className="legal-section">
            <h2>Camera and Privacy</h2>
            <p>
              The App requires camera access to function properly. By using the
              App, you consent to the App accessing your device's camera for the
              sole purpose of counting resets. All camera processing occurs
              locally on your device, and no images or video are stored,
              transmitted, or shared.
            </p>
          </section>

          <section className="legal-section">
            <h2>Data and Storage</h2>
            <p>
              The App stores your reset counts and settings locally on your
              device. This data is not transmitted to our servers or shared with
              third parties. You are responsible for backing up your data if
              needed.
            </p>
          </section>

          <section className="legal-section">
            <h2>Disclaimer of Warranties</h2>
            <p>
              THE APP IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. We
              disclaim all warranties, express or implied, including but not
              limited to warranties of merchantability, fitness for a particular
              purpose, and non-infringement.
            </p>
            <p>
              We do not guarantee that the App will be error-free,
              uninterrupted, or that defects will be corrected.
            </p>
          </section>

          <section className="legal-section">
            <h2>Limitation of Liability</h2>
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR
              ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE
              DAMAGES ARISING OUT OF OR RELATING TO YOUR USE OF THE APP.
            </p>
          </section>

          <section className="legal-section">
            <h2>Intellectual Property</h2>
            <p>
              The App and its content, including but not limited to text,
              graphics, images, and software, are owned by Sebastian Wagner
              and are protected by copyright and other intellectual property
              laws.
            </p>
          </section>

          <section className="legal-section">
            <h2>Third-Party Services</h2>
            <p>
              The App may integrate with third-party services such as app stores
              and payment processors. These services have their own terms of
              service and privacy policies, and we are not responsible for their
              content or practices.
            </p>
          </section>

          <section className="legal-section">
            <h2>Termination</h2>
            <p>
              We may terminate or suspend your access to the App at any time,
              with or without cause, with or without notice. Upon termination,
              your right to use the App will cease immediately.
            </p>
          </section>

          <section className="legal-section">
            <h2>Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. We will
              notify you of any material changes through the App or app store
              updates. Your continued use of the App after changes constitutes
              acceptance of the updated Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with
              the laws of Germany, without regard to its conflict of law
              provisions.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact Information</h2>
            <p>
              If you have any questions about these Terms of Use, please contact
              us at:
              <br />
              <a href="mailto:sebastian-wagner-96@gmx.de">
                sebastian-wagner-96@gmx.de
              </a>
            </p>
          </section>
        </div>

        <div className="legal-footer">
          <a href="/" className="back-link">
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
}
